import clsx from 'clsx';
import { useUnit } from 'effector-react';
import $$api from 'models/api';
import $$ep from 'models/ep';
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';

import useExecutionSteps from 'hooks/useExecutionSteps';
import useResources from 'hooks/useResources';

import check from 'assets/icons/check_circle_24px.svg';

const RemainingStepsTabs = () => {
    const { t } = useResources();
    const { steps } = useExecutionSteps();

    const estatePlan = useUnit($$ep.stores.$epQInstance);

    useEffect(() => {
        (async () => {
            if (estatePlan?.questionnaire_instance_id) {
                await $$api.qInstances.getDocumentsForQInstanceFx(estatePlan.questionnaire_instance_id);
            }
        })();
    }, [estatePlan?.questionnaire_instance_id]);

    const shipmentOptionsFeatureFlag = t('features.shipmentOptions') === true;

    return (
        <>
            {steps.map(({ done, label, onClick, id }, index, self) => {
                const prevStep = self[index - 1];
                return (
                    <div
                        key={id}
                        className={clsx('execution-step', {
                            'done-step': done,
                            'disabled-step': id !== 'printed' && !prevStep?.done && !done,
                        })}
                        onClick={done ? onClick : () => {}}
                    >
                        {done && <img src={check} alt="check mark" />}
                        <div className="step-text">{label}</div>
                        {(id === 'printed' || prevStep?.done) && (
                            <Button data-qaid={id + '_complete_button'} onClick={onClick}>
                                {t(
                                    `newDashboardPage.completePage.completeStep.${id}${
                                        id === 'printed'
                                            ? shipmentOptionsFeatureFlag
                                                ? '.withShipment'
                                                : '.withoutShipment'
                                            : ''
                                    }`,
                                )}
                            </Button>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default RemainingStepsTabs;
